import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CLIENTTYPE, IDTYPE } from '@shared/enums/index.enum';
import { CustomerPartnerBase } from '@shared/classes/customer-partner.base';
import { NricService } from '@shared/services/nric/nric.service';
import { SatMotorState } from '@store/sat-motor/sat-motor.state';

@Component({
  selector: 'app-customer-partner-details',
  templateUrl: './customer-partner-details.component.html',
  styleUrl: './customer-partner-details.component.scss'
})
export class CustomerPartnerDetailsComponent extends CustomerPartnerBase implements OnInit {
  @Input() customerPartnerForm: FormGroup = this.fb.group({});
  @Input() viewOnly: boolean = false;
  @Input() hideEdit: boolean = false;
  @Input() isApproval: boolean = false;
  @Input() isSummaryPage: boolean = false;
  @Input() cpType: any;
  @Input() isCompOrCustInfoIncomplete: boolean;
  @Input() isContactInfoIncomplete: boolean;
  @Input() isCorrespondenceInfoIncomplete: boolean;
  @Output() openEdit = new EventEmitter();
  @Input() viewPolicyDetails: boolean;
  @Input() pCodeInfo: any;
  @Input() isCP: boolean = false;

  @Select(SatMotorState.motorActionType) actionType$;
  @Select(SatMotorState.commonLov) commonLov$;
  isEndorsement: boolean = false;
  
  indiGeo: any;
  lovproductConfig:any;
  isEnable: boolean = false;
  productCodeKey: any;

  constructor(
    private fb: FormBuilder,
    private nricService: NricService,
    private store: Store

  ) {
    super();
  }

  ngOnInit() {
    this.indiGeo = this.store.selectSnapshot<any>((state)=>state.SatMotorState.geoCodedInd);
    this.lovproductConfig = this.lov?.productAccessConfigList;

    this.actionType$.subscribe((state) => {
      if (state.isEndorsement) {
        this.isEndorsement = true;
      }
    });
   
  }

  showNationalityDropdown(){
    if(this.isIndividual && this.cpDetails.idType1 === IDTYPE.PASS) {
      if (this.cpType === "NOT_FOUND") {
        return true;
      }else if (this.cpType === "INCOMPLETE" && this.isCompOrCustInfoIncomplete) {
        return true;
      }else {
        return false;
      }
    }else {
      return false;
    }
  }

  showNationalityText() {
    if(this.cpDetails.idType1 === IDTYPE.PASS) {
      if(this.cpType === "NOT_FOUND") {
        return false;
      }else if(this.cpType === "INCOMPLETE" && this.isCompOrCustInfoIncomplete) {
        return false;
      }else {
        return this.isIndividual;
      }
    }else {
      return this.isIndividual;
    }

  }

  showAgeAndDOB() {
    return this.cpDetails.idType1 === IDTYPE.NRIC;
  }

  getCalculateDateOfBirth(value: string): Date | string {
    try {
        return this.nricService.getDateOfBirth(value);
    } catch (error) {
        console.log('Error calculating date of birth:', error);
        return 'N/A';
    }
  }


  getCalculateAge(value) {
    return this.nricService.getAge(value);
  }

  getCalculateLatestAge() {
    if (this.isIndividual && this.cpDetails.clientDateofBirth) {
        const dateObject = new Date(this.cpDetails.clientDateofBirth);
        if (!isNaN(dateObject.getTime())) {
            const birthYear = dateObject.getFullYear();
            const currentYear = new Date().getFullYear();
            return currentYear - birthYear;
        } else {
          //Invalid date format in clientDateofBirth
          return null;
        }
    } else {
        return null;
    }
}

  onOpenEdit() {
    this.openEdit.emit();
  }

  showCustomerType() {
    return this.viewOnly || this.cpType === "FOUND";
  }

  showName() {
    return this.viewOnly || this.cpType !== "NOT_FOUND";
  }

  showIdValue() {
    return !this.isApproval;
  }

  showCOI() {
    return this.isCompany && ((this.viewOnly && !this.isApproval) || this.cpType === "FOUND" 
      || (this.cpType === "INCOMPLETE" && !this.isCompOrCustInfoIncomplete));
  }

  showNationality() {
    return this.isIndividual && (this.viewOnly  || this.cpType === "FOUND" || this.cpType === "NOT_FOUND" || (this.cpType === "INCOMPLETE" && !this.isCompOrCustInfoIncomplete));
  }

  showTin() {
    return ((this.viewOnly && !this.isApproval) || this.cpType === "FOUND" || (this.cpType === "INCOMPLETE" && !this.isCompOrCustInfoIncomplete));
  }

  showSSTAndSMESection() {
    return this.isCompany && ((this.viewOnly && !this.isApproval) || this.cpType ==="FOUND" || (this.cpType === "INCOMPLETE" && !this.isCompOrCustInfoIncomplete));
  }

  showGender() {
    return this.isIndividual && (this.viewOnly || this.cpType === "FOUND" || (this.cpType === "INCOMPLETE" && !this.isCompOrCustInfoIncomplete));
  }

  showDOB() {
    if(!this.isIndividual) {
      return false;
    }

    if([IDTYPE.POL, IDTYPE.OLD_IC, IDTYPE.PASS].includes(this.cpDetails.idType1) && (this.cpType === "NOT_FOUND" || (this.cpType === "INCOMPLETE" && this.isCompOrCustInfoIncomplete))) {
      return false;
    }

    if(!this.isApproval && this.cpDetails.idType1 === IDTYPE.NRIC) {
      return true;
    }
  
    return !this.isApproval && (this.viewOnly || this.cpType === "FOUND" || this.cpType === "NOT_FOUND" || (this.cpType === "INCOMPLETE" && !this.isCompOrCustInfoIncomplete));  
  }

  showAge() {
    if(!this.isIndividual) {
      return false;
    }

    if([IDTYPE.POL, IDTYPE.OLD_IC, IDTYPE.PASS].includes(this.cpDetails.idType1) && (this.cpType === "NOT_FOUND" || (this.cpType === "INCOMPLETE" && this.isCompOrCustInfoIncomplete))) {
      return false;
    }

    if(this.cpDetails.idType1 === IDTYPE.NRIC) {
      return true;
    }

    return this.viewOnly || this.cpDetails.clientDateofBirth;
  
  }

  showMartialStatus() {
    if(this.viewPolicyDetails){
      return this.isIndividual;
    }
    else{
      return this.isIndividual && (this.cpType === "FOUND" || (this.cpType === "INCOMPLETE" && !this.isCompOrCustInfoIncomplete) || this.viewOnly);
    }
  }

  showALIM() {
    if(this.viewPolicyDetails){
      return this.isIndividual;
    }
    else{
      return this.isIndividual && !this.isApproval && this.cpType === "FOUND";
    }
  }

  showMobileNo() {
    return !this.isApproval && (this.viewOnly || this.cpType === "FOUND" || 
    (this.cpType === "INCOMPLETE" && !this.isCompOrCustInfoIncomplete && !this.isContactInfoIncomplete && !this.isCorrespondenceInfoIncomplete));
  }

  showFixedLineNo() {
    return !this.isApproval && (this.viewOnly || this.cpType === "FOUND" || 
    (this.cpType === "INCOMPLETE" && !this.isCompOrCustInfoIncomplete && !this.isContactInfoIncomplete && !this.isCorrespondenceInfoIncomplete));
  }

  showFaxNo() {
    return !this.isApproval && (this.viewOnly || this.cpType === "FOUND" || 
    (this.cpType === "INCOMPLETE" && !this.isCompOrCustInfoIncomplete && !this.isContactInfoIncomplete && !this.isCorrespondenceInfoIncomplete));
  }

  showEmail() {
    return !this.isApproval && (this.viewOnly || this.cpType === "FOUND" || 
    (this.cpType === "INCOMPLETE" && !this.isCompOrCustInfoIncomplete && !this.isContactInfoIncomplete && !this.isCorrespondenceInfoIncomplete));
  }

  showAddress() {
    return !this.isApproval && (this.viewOnly || this.cpType === "FOUND" || 
    (this.cpType === "INCOMPLETE" && !this.isCompOrCustInfoIncomplete && !this.isContactInfoIncomplete && !this.isCorrespondenceInfoIncomplete));
  }

  showIdValue2() {
    if(!this.idValue2) {
      return false;
    }

    return ((this.viewOnly && !this.isApproval) || this.cpType === "FOUND" || (this.cpType === "INCOMPLETE" && !this.isCompOrCustInfoIncomplete));
  }

  showALIMByProdConfig(){
    
    if (this.isCP) {
      this.productCodeKey = this.pCodeInfo?.productCode;
    }
    else {
      this.productCodeKey = this.pCodeInfo?.issuance?.productCode;
    }

    if (!this.lovproductConfig) {
      this.commonLov$.subscribe((state) => {
        if (!this.lovproductConfig) {
          this.lovproductConfig = state.productAccessConfigList;
        }
      });
    }

    this.lovproductConfig?.some(item => {
      if (Object.keys(item)[0] === this.productCodeKey) {
        return this.isEnable = item[Object.keys(item)[0]].showALIMCustomer;
      }
      return false;
    });
    
    return this.isEnable;
  }

}

